import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FormOutlined, EyeOutlined } from '@ant-design/icons';
import { Table, Row, Col, Breadcrumb, Typography, Tooltip } from 'antd';
import { intialPaginationState, filter, unexpectedError, showingPageTotalRange } from '../../common_functions';

const SignatureList = props => {
  const [signature, setSignature] = useState([]);
  const [pagination, setPagination] = useState(intialPaginationState);
  const [sorter, setSorter] = useState(null);
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      render: (value, item, index) => {
        return (pagination.current - 1) * pagination.pageSize + index + 1;
      },
    },
    {
      title: 'Signature',
      dataIndex: 'signature',
      key: 'signature',
      sorter: true,
      ...filter('signature'),
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      sorter: true,
      ...filter('description'),
    },
    {
      title: 'Actions',
      key: 'action',
      render: (text, record) => (
        <span>
          <div className="actionbtngroup">
            <Link to={'/settings/signatures/' + record.id}>
              <Tooltip
                placement="top"
                title={props.roleType === 'admin' || props?.tabs_permissions?.settings_signatures?.edit ? 'Edit' : 'View'}
              >
                <button className="edit-btn">
                  {props.roleType === 'admin' || props?.tabs_permissions?.settings_signatures?.edit ? <FormOutlined /> : <EyeOutlined />}
                </button>
              </Tooltip>
            </Link>
            {props.deleteRecord(
              props,
              record.id,
              'signatures',
              'Signature?',
              signature,
              setSignature,
              props?.tabs_permissions?.settings_signatures?.delete
            )}
          </div>
        </span>
      ),
    },
  ];
  useEffect(() => {
    (async () => {
    await getSignatures(pagination);
  })();
  }, []);
  const getSignatures = async (pagination, filters = {}, sorter = '') => {
    try {
      setLoading(true);
      const response = await props.getItems('signatures', {
        fields: ['id,signature,description'],
        sort: !!sorter && sorter.field ? (sorter.order === 'ascend' ? '' : '-') + sorter.field : '-id',
        filters: filters,
        offset: pagination.pageSize * (pagination.current - 1),
        limit: pagination.pageSize,
        meta: 'filter_count',
      });
      pagination.total = response.meta.filter_count;
      setPagination(pagination);
      setSignature(response.data);
    } catch (error) {
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };

  let handleTableChange = async (pagination, filters, sorter) => {
    setPagination(pagination);
    setSorter(sorter);
    setLoading(true);
    let filtersitems = {};
    for (let key in filters) {
      if (filters.hasOwnProperty(key)) {
        let val = filters[key];
        if (val) {
          filtersitems[key] = { _icontains: val[0] };
        }
      }
    }
    await getSignatures(pagination, filtersitems, sorter);
  };

  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Settings", href: "/settings/signatures" }, { title: "Signatures" }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                View Signatures
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end">
              {props.createButton(
                props.roleType,
                props.tabs_permissions.settings_signatures,
                '/settings/signatures/new',
                'Add New Signature'
              )}
            </Col>
          </Row>
          <hr />
          <div className="artist-list">
            <Table
              scroll={{ x: 'max-content' }}
              columns={columns}
              bordered
              rowKey={record => record.id}
              dataSource={signature}
              pagination={{ ...pagination, ...showingPageTotalRange }}
              loading={loading}
              onChange={handleTableChange}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default SignatureList;
